import {
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { LayoutService } from '../services/layout.service';
import { Subscription } from 'rxjs';
import {AuthService} from '../auth/auth.service';
import { User } from '../../user/user.model';
import { Router } from '@angular/router';
import {FormControl} from '@angular/forms';
import {constants} from '../../../environments/constants';
import {ConfirmService} from '../confirm/confirm.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  hideSidebar = true;
  layoutSub: Subscription;
  user: User;
  yearFormControl: FormControl;
  currentYear: any;
  years: Number[];

  constructor(
    private layoutService: LayoutService,
    private _authService: AuthService,
    public translate: TranslateService,
    public confirmService: ConfirmService,
    private router: Router,
  ) {

    this.layoutSub = layoutService.toggleSidebar$.subscribe(
      isShow => {
        this.hideSidebar = !isShow;
      });

  }

  ngOnInit() {
    this.user = this._authService.readUserFromLocalStorage();
    this.years = this.getYears(constants.START_YEAR_FOR_FILTER);
    this.currentYear = this._authService.getSelectedYear().getValue();
    this.yearFormControl = new FormControl(this.currentYear);
  }

  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
  }

  getYears(startYear) {
    const currentYear = new Date().getFullYear(), years = [];
    startYear = startYear || 1980;
    while (startYear <= currentYear + 1) {
      years.push(startYear++);
    }
    return years;
  }

  changeYear(year) {
    this._authService.updateYear(year * 1);
  }

  logout() {
    const text = this.translate.instant('global.confirmLogout');
    const title = this.translate.instant('global.confirmLogoutTitle');
    this.confirmService.confirm({ title, text })
      .then(() => {
        this.logoutUser();
      }).catch(() => {
      console.log('Cancel')
    });
  }

  async logoutUser() {
    await this._authService.logOutUser();
    await this.router.navigate(['/']);
  }

  toggleSidebar() {
    this.layoutService.toggleSidebarSmallScreen(this.hideSidebar);
  }
}
